<template>
	<div>
		<SubNav v-bind:active="1"></SubNav>
		<div class="profile-img">
			<img :src="imgUrl" alt="">
		</div>
		<div class="profile-content" v-html="content">
		</div>
	</div>
</template>

<script>
    import SubNav from './SubNav.vue'
	import * as contactUs from '@/controller/contactUs'

	export default {
		name: "join-us",
        components: {
            SubNav
        },
		data() {
			return {
				content: '',
				imgUrl: ''
			}
		},
		mounted() {
			this.showBanner()
			this.showAbout()
		},
		methods: {
			//显示banner图
			showBanner() {
				contactUs.fetchBanner()
					.then(result => {
						this.imgUrl = result.imgUrl.recruit
					})
			},
			//显示内容
			showAbout() {
				contactUs.fetchJoinUs()
					.then(result => {
						this.content = result.content
					})
			}
		}
	}
</script>

<style scoped lang="stylus">
	.profile-img
		background-color white
		overflow hidden
		img
			width 100%
	.profile-content
		max-width 1000px
		margin 0 auto
		padding 20px 10px
	.profile-content >>> img
		max-width 100%
</style>